import moment from "moment-timezone";

import { durationToString } from "@/utils/momentUtils";

export const renderSessionMetaData = (dateStr, note, patientName) => {
  let timing = "";
  let totalDuration = "";

  if (note.session_date && note.session_to && note.session_from) {
    timing = note.session_from + " to " + note.session_to;
    let momentTo = moment(note.session_date + " " + note.session_to);
    let momentFrom = moment(note.session_date + " " + note.session_from);
    let diff = moment.duration(momentTo.diff(momentFrom));

    totalDuration = durationToString(diff);
  }

  return (
    <div className="row">
      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Patient Name</label>
          <p>{patientName}</p>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Linked Call</label>
          <p>{note["call_name"]}</p>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Session Date</label>
          <p>{dateStr}</p>
        </div>
      </div>

      <div className="col-6 col-lg-3">
        <div>
          <label className="Label">Timing</label>
          <p>{timing}</p>
        </div>
      </div>

      <div className="col-6 col-lg-3">
        <div>
          <label className="Label">Duration</label>
          <p>{totalDuration}</p>
        </div>
      </div>
    </div>
  );
};
